import {useMemo} from 'react';
import {useCheckoutBasketItems} from './useCheckoutBasketItems';

export const useCheckoutBasketContainsHypedItems = () => {
  const basketItems = useCheckoutBasketItems();

  return useMemo(() => {
    return basketItems.some(item => item.captchaRequired);
  }, [basketItems]);
};
